<template>
  <generic-create :model="model">
    <template v-slot:form="{ error, submit }">
      <band-form :error="error" :loading="false" @submit="submit" />
    </template>
  </generic-create>
</template>

<script>
import BandForm from "./Form"
import model from "./model"

export default {
  components: { BandForm },
  data() {
    return { model }
  },
}
</script>
